import React, { useState } from 'react';
import EditorMission from '../editorMission/EditorMission.jsx';
import WritingJobNavigation from '../writingJobFlow/WritingJobNavigation.jsx';
import { missionView } from '../editorMission/model.js';
import LessonMedia from '../lessonMedia/LessonMedia.jsx';
import { mediaVisible } from '../lessonMedia/model.js';
import BoundLessonMedia from './BoundLessonMedia.jsx';
function MediaDisclosure({ title, common, role }) {
    const [open, setOpen] = useState(false);
    if (!mediaVisible(common.content, { ...common, roles: [role], hintShown: true, revealed: true }).length) return null;
    return <div className="my-3"><button type="button" className="px-3 py-2 rounded-full border border-book-line" aria-expanded={open} onClick={() => setOpen(!open)}>{open ? 'Hide ' : 'Show '}{title}</button>
        {open && <LessonMedia {...common} roles={[role]} hintShown={role === 'hint'} revealed={role === 'answer'} />}</div>;
}
export default function LessonPartExtras({ content, partId, placement = 'before', options = {} }) {
    const [local, setLocal] = useState({});
    const mission = missionView(content), ownsMission = mission?.partId === partId;
    const state = options.state || local, onChange = options.onChange || setLocal;
    const common = { content, partId, placement, packId: options.packId, availableAudios: options.availableAudios || [], mode: options.independent ? 'independent' : 'learn' };
    return <>
        <LessonMedia {...common} roles={['context','explanation']} />
        <MediaDisclosure key={partId + '/' + placement + '/hint'} title="optional media hint" common={common} role="hint" />
        <MediaDisclosure key={partId + '/' + placement + '/answer'} title="suggested-answer media" common={common} role="answer" />
        {ownsMission && placement === 'after' && <EditorMission content={content} partId={partId} state={state} onChange={onChange} independent={!!options.independent}
            renderStudyNavigation={options.writingJobNavigation ? settings => <WritingJobNavigation {...settings} config={options.writingJobNavigation} packId={options.packId} /> : undefined}
            renderMedia={settings => <BoundLessonMedia content={content} partId={partId} options={options} {...settings} missionQuestion />} />}
    </>;
}
